
export default {
  // Tu script aquí
};
